/*
    Validation context for Job application
*/

export const INTERESTED_JOB_APPLICATION_VALIDATION_CONTEXT = {
    arrayEmpty: {
        attachments: 'Attach CVs / Documents'
    }
}